module.exports = __webpack_public_path__ + "static/media/medic-build.98d08f77.png";